import React from 'react';
import PropTypes from 'prop-types';
import { Text } from '@nerdwallet/react-typography';

var Fee = function Fee(_ref) {
  var data = _ref.data,
      noSuffix = _ref.noSuffix;

  if (data.tradeFee === null || data.tradeFee === undefined) {
    return null;
  }

  var suffix = data.tradeFeeCaption;

  if (suffix) {
    suffix = React.createElement("span", {
      className: "annotation"
    }, React.createElement(Text, {
      small: true
    }, suffix));
  }

  if (noSuffix) {
    suffix = null;
  }

  return React.createElement("div", {
    className: "product-label product-value"
  }, "$".concat(data.tradeFee), suffix);
};

Fee.propTypes = {
  data: PropTypes.object,
  noSuffix: PropTypes.bool
};
export default Fee;